import { AsyncPipe } from '@angular/common';
import { Component, inject, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgbToast } from '@ng-bootstrap/ng-bootstrap';
import { Subject, takeUntil } from 'rxjs';
import { PwaInstallService } from './core/services/pwa-install.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AsyncPipe, NgbToast],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnDestroy {
  title = 'APP Pacientes';

  private destroy$ = new Subject<void>(); // Observable de finalización
  pwaInstallService = inject(PwaInstallService);
  isInstallable$ = this.pwaInstallService.installPrompt$;
  isLoading$ = this.pwaInstallService.loading$.pipe(takeUntil(this.destroy$)); // Tomar hasta que se destruya

  installPwa(): void {
    this.pwaInstallService.installPwa();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete(); // Completa el observable al destruir el componente
  }
}
